import { render } from "./ProgramGraduationReport.vue?vue&type=template&id=64c0b785&ts=true"
import script from "./ProgramGraduationReport.vue?vue&type=script&lang=ts"
export * from "./ProgramGraduationReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__